import axios from '../plugins/axios';

const API_URL = '/admin/rooms';

export default {
  async getRooms(filters = {}) {
    let url = API_URL;
    
    if (filters.name) {
      url += `?_filters_[]=name__contains&name__contains=${encodeURIComponent(filters.name)}`;
    }
    
    console.log('API Request URL:', url);
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data);
      
      if (response.data && response.data.data && response.data.data.data) {
        return {
          success: response.data.success,
          data: response.data.data.data
        };
      }
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async addRoom(roomData) {
    const response = await axios.post(API_URL, roomData);
    return response.data;
  },

  async updateRoom(roomId, roomData) {
    const response = await axios.put(`${API_URL}/${roomId}`, roomData);
    return response.data;
  },

  async deleteRoom(roomId) {
    const response = await axios.delete(`${API_URL}/${roomId}`);
    return response.data;
  },

  async getAvailableDates(roomId, bookingType) {
    try {
      console.log(`Fetching dates for room ${roomId} with type ${bookingType}`);
      const response = await axios.get(`${API_URL}/${roomId}/bookings?room_id=${roomId}&type=${bookingType}`);
      console.log('Raw API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching available dates:', error);
      throw error;
    }
  },
  

}; 